import React from 'react';

import { bemCssModules, correctingTrailingNumbers } from '@cryptoboyio/mercuryo-lab/utils';

import { getTestId } from '@utils';
import { useTotalDigits } from '@utils/hooks';

import { CurrencyEnum } from '@modules/global/types';

import style from './Exchange.scss';

const cn = bemCssModules(style, 'Exchange');
const ti = getTestId('Exchange');

export type ExchangeType = {
  currency: CurrencyEnum;
  type: string;
  amount: string;
  amountTestId?: string;
  currencyTestId?: string;
};

export const Exchange: CustomFC<ExchangeType> = props => {
  const { currency, type, amount, amountTestId, currencyTestId } = props;

  const { getTotalDigits, getDisplayDigits } = useTotalDigits();
  const totalDigits = getTotalDigits(currency);
  const displayDigits = getDisplayDigits(currency);
  const value = correctingTrailingNumbers(amount, displayDigits, totalDigits);

  return (
    <>
      <span className={cn('currency')} data-testid={ti(currencyTestId)}>
        {currency}
      </span>
      <span className={cn('amount', { type })} data-testid={ti(amountTestId)}>
        {value}
      </span>
    </>
  );
};

export default Exchange;
